module.exports = __webpack_public_path__ + "vue/img/welcome.e0d51b7d.jpg";